import { render, staticRenderFns } from "./index.vue?vue&type=template&id=051de2a4&v=1.0.0"
import script from "./index.vue?vue&type=script&lang=js&v=1.0.0"
export * from "./index.vue?vue&type=script&lang=js&v=1.0.0"
import style0 from "./index.vue?vue&type=style&index=0&id=051de2a4&prod&lang=css&v=1.0.0"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports